<template>
  <div class="yk-share-manage-mentattached clearfix">
     <MaterialFile :url="urlAliyunOSS" format="image" :fileList.sync="list" :count="100"></MaterialFile>
     <el-button type="primary" @click="sort()" v-if="list.length>0">图片排序</el-button>
     <div v-for="(item, index) in list" :index="index" :key="index" class="exhibition-content">
       <img :src="item.url" style="width:100%;"/>
     </div>
     <div class="btn-text-right">
       <el-button type="primary" @click="saveAttached">保存</el-button>
     </div>
     <el-dialog title="图片排序" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" width="60%" top="5%" :before-close="handleClose">
      <div class="root">
        <sortable-list class="clearfix" lockAxis="y" v-model="list" helperClass="sortable-fixed-sortitem" @input="onInput">
          <sortable-item v-for="(item, index) in list" :index="index" :key="index" :item="item" style="background-color:#fff">
            <div class="sortInfo" style="color:#606266">{{ item.name }}
              <img src="~assets/images/yidong.png" style="width:21px;height:21px;float:right;margin:8px;cursor: pointer;" />
            </div>
          </sortable-item>
        </sortable-list>
      </div>
    </el-dialog>
    
  </div>
  
</template>

<script>
import Vue from "vue";
import { ContainerMixin, ElementMixin } from 'vue-slicksort';
import MaterialFile from "components/AliyunOSS/MaterialFile.vue";
 
import { Message } from "element-ui";
const SortableList = {
  name:'sortablelist',
  mixins: [ContainerMixin],
  template: `
    <ul class="sortable-list">
      <slot />
    </ul>
  `,
};

const SortableItem = {
  name:'sortableitem',
  mixins: [ElementMixin],
  template: `
    <li class="sortable-list-item">
      <slot />
    </li>
  `,
};
export default Vue.extend({
  name: "TeaTextBook",
  components: {
    MaterialFile,
    SortableItem,
    SortableList,
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      list:[],
        urlAliyunOSS: '/api/design/osssign/getsign',
      dialogVisible:false,
    };
  },
  created(){
    this.getAttachedImg();
  },
  watch:{
  },
  methods: {
    getAttachedImg(){
      var that=this;
      this.$http.post("/api/manager/BookMaterial/getAttachedImg",
      {
        courseId:that.courseId,
      }).then(rst =>{
        if(rst.code > 0){
          if(rst.img!=""){
            that.list=JSON.parse(rst.img);
          }
        }
      });
    },
    addAttached(){
      var that=this;
      let fjImg=[];
      that.list.forEach(function (item, index) {
        fjImg.push({
          docId:item.docId,
          name:item.name,
          url:item.url
        })
      });
      this.$http.post("/api/manager/BookMaterial/addAttached",
      {
        courseId:that.courseId,
        attachedUrl:JSON.stringify(fjImg)
      }).then(rst =>{
        if(rst.code > 0){
          that.$message.success("修改成功");
        }
      });
    },
    handleClose(){
      this.dialogVisible = false;
    },
    onInput(newList) {
      this.list=newList;
    },
    saveAttached(){
      this.addAttached();
    },
    sort(){
      var list=[];
      if(typeof this.list === 'string' || this.list==""){
        this.$message({
          type: "info",
          message: "当前小于两张图片"
        });
      }
      this.list.forEach(item=>{
        if(item.url==undefined){
          list.push({
            name:item.name,
            url:item.uel,
            docId: res.docId
          });
        }else{
          return false;
        }
      });
      if(list.length>0){
        this.list=list;
      }
      this.dialogVisible = true;
    },
  }
});
</script>

<style lang="scss">
.yk-share-manage-mentattached{
  position: relative;
  padding:20px;
  .el-upload__tip{
    display: inline-block;
    color: red;
  }
  .exhibition-content{
    width: 70%;
    margin: 5px auto;
  }
  .btn-text-right{
    position: absolute;
    top: -49px;
    right: 197px;
    .el-button{
      padding: 10px 20px;
    }
  }
}
</style>